import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

const module = {
  state: {
    notices:[]
  },

  getters: {},

  mutations: {},

  actions: {
    async C00101_initData({ state }, payload) {
      const result = await ApiUtils.postData({
        data: {
          C00101_getNotice: { api: 'T0030NoticeService.C00101_getNotice', input: payload }
        }
      })
      state.notices = result.C00101_getNotice.output;
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
